import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import {
  MdRecordVoiceOver,
  MdBusiness,
  MdPeople,
  MdRefresh,
  MdDeviceHub,
  MdArrowForward,
} from 'react-icons/md';
import { useSelector } from 'react-redux';
import { formatPrice } from '~/util/formatPrice';
import api from '~/services/api';
import history from '~/services/history';
import {
  Container,
  Cards,
  Block,
  Info,
  Icon,
  Menu,
  Dados,
  Dev,
} from './styles';
import Load from '~/components/Load';

export default function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [leadsSize, setLeadsSize] = useState(0);
  const [atrasadoSize, setAtrasadoSize] = useState(0);
  const [saldoVoice, setSaldoVoice] = useState(0);
  const [tentativasHoje, setTentativasHoje] = useState(0);
  const user = useSelector(state => state.user.profile);

  const getLeads = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/painel-atendimento-totais');
      setLeadsSize(response.data);
    } catch (error) {
      toast.error('Sistema esta forá do ar, aguarde um instante.');
    } finally {
      setLoading(false);
    }
  }, []);

  const getTarefas = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/tarefas');
      setTentativasHoje(response.data.length);
    } catch (error) {
      toast.error('Sistema esta forá do ar, aguarde um instante.');
    } finally {
      setLoading(false);
    }
  }, []);

  const getLeadAtrasados = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/atividade-countD');
      setAtrasadoSize(response.data);
    } catch (error) {
      toast.error('Sistema esta forá do ar, aguarde um instante.');
    } finally {
      setLoading(false);
    }
  }, []);

  const getVoiceSaldo = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/voice-saldo');
      setSaldoVoice(formatPrice(response.data));
    } catch (error) {
      toast.error('Token do total voice invalido, verifique seu token.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getLeads();
    getTarefas();
    getLeadAtrasados();
    getVoiceSaldo();
  }, [getLeadAtrasados, getLeads, getTarefas, getVoiceSaldo]);

  if (loading) {
    return (
      <Dev>
        <Load />
      </Dev>
    );
  }
  return (
    <Container>
      <h4>Dashboard</h4>
      <span>Bem-vindo ao LeadFlow</span>
      <Cards user={user.provider}>
        <Block>
          <Dados>
            <Icon>
              <MdBusiness size={30} color="#FFF" />
            </Icon>
            <Info>
              <h4>Leads totais</h4>
              <span>{leadsSize}</span>
            </Info>
          </Dados>
          <Menu>
            <h4>Acessar agora</h4>
            <button type="button" onClick={() => history.push('/leads')}>
              <MdArrowForward size={24} color="rgba(255,255,255,.9)" />
            </button>
          </Menu>
        </Block>
        <Block>
          <Dados>
            <Icon>
              <MdPeople size={30} color="#FFF" />
            </Icon>
            <Info>
              <h4>Tarefas atrasadas</h4>
              <span>{atrasadoSize}</span>
            </Info>
          </Dados>
          <Menu>
            <h4>Atualizar agora</h4>
            <button type="button" onClick={() => getLeadAtrasados()}>
              <MdRefresh size={24} color="rgba(255,255,255,.9)" />
            </button>
          </Menu>
        </Block>
        <Block>
          <Dados>
            <Icon>
              <MdRecordVoiceOver size={30} color="#FFF" />
            </Icon>
            <Info>
              <h4>Saldo Total Voice</h4>
              <span>{saldoVoice}</span>
            </Info>
          </Dados>
          <Menu>
            <h4>Atualizar agora</h4>
            <button type="button" onClick={() => getVoiceSaldo()}>
              <MdRefresh size={24} color="rgba(255,255,255,.9)" />
            </button>
          </Menu>
        </Block>
        <Block>
          <Dados>
            <Icon>
              <MdDeviceHub size={30} color="#FFF" />
            </Icon>
            <Info>
              <h4>Tentativas do dia</h4>
              <span>{tentativasHoje}</span>
            </Info>
          </Dados>
          <Menu>
            <h4>Atualizar agora</h4>
            <button type="button" onClick={() => getTarefas()}>
              <MdRefresh size={24} color="rgba(255,255,255,.9)" />
            </button>
          </Menu>
        </Block>
      </Cards>
    </Container>
  );
}
